import core from "@gtmhub/core/module";
import env from "@gtmhub/env/module";
import uiBootstrap from "@gtmhub/ui-bootstrap.module";
import mentions from "@gtmhub/shared/mentions/module";
import experiments from "@gtmhub/experiments/experiments.module";
import { ThreadCtrl } from "./controllers/thread";
import { CommentService } from "./services/comment-service";
import { CommentsComponent } from "./components/comments";
import { CommentEditorComponent } from "./components/comment-editor/comment-editor.component";

const mod = angular.module("comments", [core, env, mentions, experiments, uiBootstrap]);
mod.service("CommentService", CommentService);
mod.controller("ThreadCtrl", ThreadCtrl);
mod.component("ghComments", CommentsComponent);
mod.component("ghCommentEditor", CommentEditorComponent);

export default mod.name;
